import * as React from "react";
import WSProgressBar from "../../Workspace2/WSProgressBar";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Badge from "@mui/material/Badge";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import Checkbox from "@mui/material/Checkbox";
// import button from "@mui/material/Button";
import { motion } from "framer-motion";
import moment from "moment";

import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../../Workspace2/sidebar.css";
// import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router";
import { GetCheckedIR, UpdateStepStatus, getAllFixedAssetsApiHandler, getAllPurchaseApiHandler, getAllSaleApiHandler, getWorkspace } from "../ApiServices/apiHandler";
import { useEffect } from "react";
import { useState } from "react";
import useFetchApi from "../../../services/CustomHook/useFetchApi";
import { Link, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import "..//../../WorkSpace/font.css";
import WorkspaceHeader from "./WorkspaceHeader";
import swal from "sweetalert";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import "./../..././../../../WorkSpace/SignUp2.css";
import CircleIcon from '@mui/icons-material/Circle';
import { ReactComponent as CircleCheckIcon } from '../../../myfin_v2/assets/icons/circle_check2.svg'

import {
  CreateCompany,
  GetLoan,
  // getCheckData,
  GetAllCompany,
  GetLease,
  GetPayable,
  GetReceivable,
  getActivePlan
} from "../ApiServices/apiHandler";

import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css"
import { ReactComponent as RightIcon } from "../../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as PervBtnIcon } from '../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import { ReactComponent as SearchIcon } from '../../../myfin_v2/assets/icons/search.svg'


const label = { inputProps: { "aria-label": "Checkbox demo" } };

const ImportRegistersV2 = (props) => {
  const { id } = useParams();
  let history = useHistory();
  const user = JSON.parse(localStorage.getItem('user'));
  const [company, setCompany] = useState([]);
  const [singleWorkspace, setSingleWorkspace] = useState([]);

  const [loans, setLoans] = useState([]);
  const [selectedLoans, setSelectedLoans] = useState([]);
  const [loanImported, setLoanImported] = useState(false)
  const [isOpenLoan, setIsOpenLoan] = useState(false);

  const [leases, setLeases] = useState([]);
  const [selectedLeases, setSelectedLeases] = useState([]);
  const [leasesImported, setLeasesImported] = useState(false);
  const [isOpenLeases, setIsOpenLeases] = useState(false);

  const [receivable, setReceivable] = useState([]);
  const [selectedReceivable, setSelectedReceivable] = useState([]);
  const [receivableImported, setReceivableImported] = useState(false);
  const [isOpenReceivable, setIsOpenReceivable] = useState(false);

  const [payable, setPayable] = useState([]);
  const [selectedPayable, setSelectedPayable] = useState([]);
  const [payableImported, setPayableImported] = useState(false);
  const [isOpenPayable, setIsOpenPayable] = useState(false);

  const [fixedAssets, setFixedAssets] = useState([]);
  const [selectedFixedAssets, setSelectedFixedAssets] = useState([]);
  const [fixedAssetsImported, setFixedAssetsImported] = useState(false);

  const [saleReg, setSaleReg] = useState([]);
  const [selectedSaleReg, setSelectedSaleReg] = useState([]);
  const [saleRegImported, setSaleRegImported] = useState(false);

  const [purchaseReg, setPurchaseReg] = useState([]);
  const [selectedPurchaseReg, setSelectedPurchaseReg] = useState([]);
  const [purchaseRegImported, setPurchaseRegImported] = useState(false);

  const [investments, setInvestments] = useState([]);
  const [selectedInvestments, setSelectedInvestments] = useState([]);
  const [investmentImported, setInvestmentImported] = useState(false);
  const [isOpenInvestment, setIsOpenInvestment] = useState(false);

  const [activePlanData, setActivePlanData] = useState([]);

  const nextPageData = async () => {
    try {
      const data = {
        steps: "step4",
        has_published: "draft",
        status: singleWorkspace.status,
        approver_id: singleWorkspace.approver_id,
        cancel_reason: singleWorkspace.cancel_reason,
      };
      const res = await UpdateStepStatus(id, data);
      if (res.status === 200) {
        history.push(`/importPreset/${id}`);
      }
    } catch (error) {
      console.log("error", error.message);
      return 0;
    }
  };

  const skipNext = async () => {
    history.push(`/importPreset/${id}`);
  };

  const { loading, response, error } = useFetchApi(
    `api/v1/company-data/all-IR`
  );
  useEffect(() => {
    if (response && Object.keys(response).length > 0) {
      setInvestments(response.data.fetchIR);
    }
    if (error) {
      swal("Error", error, "error");
    }
    getIr();
    companyData();
    getLoans();
    getLeases();
    getPayable();
    getReceivable();
    getSingleWorkspace();
    getAllFixedAssetsRegs();
    getAllSaleRegs();
    getAllPurchaseRegs();
  }, [response || error]);

  useEffect(() => {
    activePlan();
  }, [])

  const getSingleWorkspace = async () => {
    const res = await getWorkspace(id);
    if (res.status === 200) {
      setSingleWorkspace(res.data?.getworkspace[0])
    }
  }

  const handleOpenLoan = () => {
    setIsOpenLoan(!isOpenLoan);
  }
  const handleOpenLeases = () => {
    setIsOpenLeases(!isOpenLeases);
  }
  const handleOpenInvestment = () => {
    setIsOpenInvestment(!isOpenInvestment);
  }
  const handleOpenReceivable = () => {
    setIsOpenReceivable(!isOpenReceivable);
  }
  const handleOpenPayable = () => {
    setIsOpenPayable(!isOpenPayable);
  }

  const companyData = async () => {
    try {
      const res = await GetAllCompany();
      if (res.status === 200) {
        setCompany(res.data.getAllCompanyData)
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const companyName = (c_id) => {
    try {
      const nameCompany = company.filter((adj) => adj._id === c_id);
      const result = nameCompany[0]?.company_name
        ? nameCompany[0]?.company_name
        : "unknown";
      return result;
    } catch (error) {
      return 0;
    }
  };
  const updateCheckedIR = (key, checked_data) => {
    const data = {
      w_id: id,
      [key]: checked_data
    }
    CreateCompany(data).then(res => {
      getIr();
      return res
    }).catch(err => {
      swal("Error", err, "error");
      return err
    })
  }

  const getLoans = async () => {
    try {
      const res = await GetLoan();
      if (res.status === 200) {
        setLoans(res.data.loans);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const getPayable = async () => {
    try {
      const res = await GetPayable();
      if (res.status === 200) {
        setPayable(res.data.payables);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const getReceivable = async () => {
    try {
      const res = await GetReceivable();
      if (res.status === 200) {
        setReceivable(res.data.receivables);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const getAllFixedAssetsRegs = async () => {
    try {
      const res = await getAllFixedAssetsApiHandler();
      if (res.status === 200) {
        setFixedAssets(res?.data?.fixedAssets);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const getAllSaleRegs = async () => {
    try {
      const res = await getAllSaleApiHandler();
      console.log("sale res",res);
      
      if (res.status === 200) {
        setSaleReg(res?.data?.sales);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const getAllPurchaseRegs = async () => {
    try {
      const res = await getAllPurchaseApiHandler();
      console.log("Purchase res",res);
      
      if (res.status === 200) {
        setPurchaseReg(res?.data?.purchases);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };


  const handleSelectLoans = (event, id) => {
    setSelectedLoans((prevItems) => {
      // If the value is checked, push it to the array; otherwise, remove it
      if (prevItems.includes(id)) {
        updateCheckedIR("all_checked_loans", selectedLoans.filter((item) => item !== id));
        return prevItems.filter((item) => item !== id);
      } else {
        setLoanImported(false)
        return [...prevItems, id];
      }
    })
  };

  const importAllLoans = async () => {
    const allLoansIds = loans.map((loan) => loan._id);
    setSelectedLoans(allLoansIds);
    await updateCheckedIR("all_checked_loans", allLoansIds);
  }

  const getLeases = async () => {
    try {
      const res = await GetLease();
      if (res.status === 200) {
        setLeases(res.data.projects);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const handleSelectLeases = (event, id) => {
    setSelectedLeases((prevItems) => {
      // If the value is checked, push it to the array; otherwise, remove it
      if (prevItems.includes(id)) {
        updateCheckedIR("all_checked_leases", selectedLeases.filter((item) => item !== id));
        return prevItems.filter((item) => item !== id);
      } else {
        setLeasesImported(false)
        return [...prevItems, id];
      }
    })
  };

  const importAllLeases = async () => {
    const allLeasesIds = leases.map((lease) => lease._id)
    setSelectedLeases(allLeasesIds)
    await updateCheckedIR("all_checked_leases", allLeasesIds);
  }

  const handleSelectInvestment = (event, id) => {
    setSelectedInvestments((prevItems) => {
      // If the value is checked, push it to the array; otherwise, remove it
      if (prevItems.includes(id)) {
        updateCheckedIR("all_checked_investment", selectedInvestments.filter((item) => item !== id));
        return prevItems.filter((item) => item !== id);
      } else {
        setInvestmentImported(false)
        return [...prevItems, id];
      }
    })
  };

  const importAllInvestment = async () => {
    const allInvestmentIds = investments.map((investment) => investment._id)
    setSelectedInvestments(allInvestmentIds)
    await updateCheckedIR("all_checked_investment", allInvestmentIds);
  }

  const handleSelectReceivable = (event, id) => {
    setSelectedReceivable((prevItems) => {
      // If the value is checked, push it to the array; otherwise, remove it
      if (prevItems.includes(id)) {
        updateCheckedIR("all_checked_receivable", selectedReceivable.filter((item) => item !== id));
        return prevItems.filter((item) => item !== id);
      } else {
        setReceivableImported(false)
        return [...prevItems, id];
      }
    })
  };

  const importAllReceivable = async () => {
    const allReceivableIds = receivable.map((receivable) => receivable._id);
    setSelectedReceivable(allReceivableIds);
    await updateCheckedIR("all_checked_receivable", allReceivableIds);
  }

  const handleSelectPayable = (event, id) => {
    setSelectedPayable((prevItems) => {
      // If the value is checked, push it to the array; otherwise, remove it
      if (prevItems.includes(id)) {
        updateCheckedIR("all_checked_payable", selectedPayable.filter((item) => item !== id));
        return prevItems.filter((item) => item !== id);
      } else {
        setPayableImported(false)
        return [...prevItems, id];
      }
    })
  };

  const importAllPayable = async () => {
    const allPayableIds = payable.map((payable) => payable._id);
    setSelectedPayable(allPayableIds);
    await updateCheckedIR("all_checked_payable", allPayableIds);
  }

  const importAllFixedAssets = async () => {
    const allFixedAssetsIds = fixedAssets.map((fa) => fa._id);
    setSelectedFixedAssets(allFixedAssetsIds);
    await updateCheckedIR("all_checked_fixed_assets", allFixedAssetsIds);
  }

  const handleSelectFixedAssets = (event, id) => {
    setSelectedFixedAssets((prevItems) => {
      // If the value is checked, push it to the array; otherwise, remove it
      if (prevItems.includes(id)) {
        updateCheckedIR("all_checked_fixed_assets", selectedFixedAssets.filter((item) => item !== id));
        return prevItems.filter((item) => item !== id);
      } else {
        setFixedAssetsImported(false)
        return [...prevItems, id];
      }
    })
  };

  const importAllSalesReg = async () => {
    const allSalesRegsIds = saleReg.map((fa) => fa._id);
    setSelectedSaleReg(allSalesRegsIds);
    await updateCheckedIR("all_checked_sale", allSalesRegsIds);
  }

  const handleSelectSalesReg = (event, id) => {
    setSelectedSaleReg((prevItems) => {
      // If the value is checked, push it to the array; otherwise, remove it
      if (prevItems.includes(id)) {
        updateCheckedIR("all_checked_sale", selectedSaleReg.filter((item) => item !== id));
        return prevItems.filter((item) => item !== id);
      } else {
        setSaleRegImported(false)
        return [...prevItems, id];
      }
    })
  };


  const importAllPurchaseReg = async () => {
    const allPurchaseRegsIds = purchaseReg.map((fa) => fa._id);
    setSelectedPurchaseReg(allPurchaseRegsIds);
    await updateCheckedIR("all_checked_purchase", allPurchaseRegsIds);
  }

  const handleSelectPurchaseReg = (event, id) => {
    setSelectedPurchaseReg((prevItems) => {
      // If the value is checked, push it to the array; otherwise, remove it
      if (prevItems.includes(id)) {
        updateCheckedIR("all_checked_purchase", selectedPurchaseReg.filter((item) => item !== id));
        return prevItems.filter((item) => item !== id);
      } else {
        setPayableImported(false)
        return [...prevItems, id];
      }
    })
  };

  const getIr = async () => {
    const res = await GetCheckedIR(id);
    if (res.status === 200) {
      if (res.data.getIR.length > 0) {
        if (res.data.getIR[0].all_checked_loans.length > 0) {
          setLoanImported(true)
          setSelectedLoans(res.data.getIR[0].all_checked_loans)
        } else {
          setLoanImported(false)
        }

        if (res.data.getIR[0].all_checked_leases.length > 0) {
          setLeasesImported(true)
          setSelectedLeases(res.data.getIR[0].all_checked_leases)
        } else {
          setLeasesImported(false)
        }

        if (res.data.getIR[0].all_checked_investment.length > 0) {
          setInvestmentImported(true)
          setSelectedInvestments(res.data.getIR[0].all_checked_investment)
        } else {
          setInvestmentImported(false)
        }

        if (res.data.getIR[0]?.all_checked_receivable?.length > 0) {
          setReceivableImported(true)
          setSelectedReceivable(res.data.getIR[0]?.all_checked_receivable)
        } else {
          setReceivableImported(false)
        }

        if (res.data.getIR[0]?.all_checked_payable?.length > 0) {
          setPayableImported(true)
          setSelectedPayable(res.data.getIR[0]?.all_checked_payable)
        } else {
          setPayableImported(false)
        }
      }
    }
  };

  const activePlan = async () => {
    try {
      const res = await getActivePlan();
      setActivePlanData(res.data.categorizedBenefits.dataset);

    } catch (error) {
      console.log(error.message)
    }
  }

  const [activeTab, setActiveTab] = useState("Investment");
  const isDisabled = user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view";

  return (
    <>
      <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
        <div>
          <WSProgressBar activePage={4} id={id} />
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }} className={wsCreationcss.wsContentDiv}>
          <span className={`${wsCreationcss.wsContentHeading} mb-3 mt-3`}>
            Ready to import registers?
          </span>

          <div className={`${wsCreationcss.regContainer} mt-2`}>
            {/* Tabs */}
            <div className={wsCreationcss.tabButtons}>
              {/* {activePlanData.includes("Sales") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Sales" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Sales")}
                >
                  Sales {receivableImported && <CircleCheckIcon className="mr-2 mb-1" />}
                </div>
              )} */}
              {/* {activePlanData.includes("Purchases") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Purchases" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Purchases")}
                >
                  Purchases {receivableImported && <CircleCheckIcon className="mr-2 mb-1" />}
                </div>
              )} */}
              {activePlanData.includes("Investment") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Investment" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Investment")}
                >
                  {investmentImported && <CircleCheckIcon className="mr-2 mb-1" />}Investment
                </div>
              )}
              {activePlanData.includes("Leases") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Leases" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Leases")}
                >
                  {leasesImported && <CircleCheckIcon className="mr-2 mb-1" />}Leases
                </div>
              )}
              {/* {activePlanData.includes("Fixed Assets") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Fixed Assets" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Fixed Assets")}
                >
                  Fixed Assets {receivableImported && <CircleCheckIcon className="mr-2 mb-1" />}
                </div>
              )} */}
              {activePlanData.includes("Receivables") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Receivables" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Receivables")}
                >
                  {receivableImported && <CircleCheckIcon className="mr-2 mb-1" />}Receivables
                </div>
              )}
              {activePlanData.includes("Payables") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Payables" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Payables")}
                >
                  {payableImported && <CircleCheckIcon className="mr-2 mb-1" />}Payables
                </div>
              )}
              {/* {activePlanData.includes("Presets") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Presets" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Presets")}
                >
                  Presets {receivableImported && <CircleCheckIcon className="mr-2 mb-1" />}
                </div>
              )} */}
              {activePlanData.includes("Loans") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Loans" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Loans")}
                >
                  {loanImported && <CircleCheckIcon className="mr-2 mb-1" />}Loans
                </div>
              )}

              {activePlanData.includes("Fixed Assets") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Fixed Assets" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Fixed Assets")}
                >
                  {fixedAssetsImported && <CircleCheckIcon className="mr-2 mb-1" />}Fixed Assets
                </div>
              )}

              {activePlanData.includes("Sales") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Sales" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Sales")}
                >
                  {fixedAssetsImported && <CircleCheckIcon className="mr-2 mb-1" />}Sales
                </div>
              )}

              {activePlanData.includes("Purchases") && (
                <div
                  className={`${wsCreationcss.tabButton} ${activeTab === "Purchases" ? wsCreationcss.activeTab : ""}`}
                  onClick={() => setActiveTab("Purchases")}
                >
                  {fixedAssetsImported && <CircleCheckIcon className="mr-2 mb-1" />}Purchases
                </div>
              )}
            </div>

            {/* Content */}
            <div className={wsCreationcss.tabContent}>
              {activeTab === "Investment" && (
                <>
                  <div className={wsCreationcss.scrollArea}>
                    {investments.map((investment) => (
                      investment.ir_name && (
                        <div className="d-flex mb-2" key={investment._id} style={{ "align-items": "center" }}>
                          <input
                            style={{ "margin": "-20px 20px 0px 0px" }}
                            type="checkbox"
                            checked={selectedInvestments.includes(investment._id)}
                            disabled={isDisabled}
                            onChange={(e) => handleSelectInvestment(e, investment._id)}
                          />
                          <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "90%", "margin-bottom": "15px" }}>
                            <div className={commoncss.dFlexClm}>
                              <span className={wsCreationcss.wscLabel2}>
                                {investment.ir_name}
                              </span>
                              <span className={wsCreationcss.wscLabel3}>
                                {companyName(investment.parent_company_id)}
                              </span>
                            </div>
                            <div className="d-flex" style={{ "gap": "14px" }}>
                              <div className={wsCreationcss.wscCard1}>
                                <span className={wsCreationcss.wscLabel4}>From</span>
                                <span className={wsCreationcss.wscLabel5}>DD-MM-YYYY</span>
                              </div>
                              <div className={wsCreationcss.wscCard1}>
                                <span className={wsCreationcss.wscLabel4}>To</span>
                                <span className={wsCreationcss.wscLabel5}>DD-MM-YYYY</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    ))}
                  </div>
                  <hr />
                  <div className={commoncss.dFlexJustifysb}>
                    <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                      onClick={() => updateCheckedIR("all_checked_investment", selectedInvestments)}
                      disabled={user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view"}
                    >Import selected investment</button>&ensp;
                    <button className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
                      onClick={importAllInvestment}
                      disabled={user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view"}
                    >Import all investment</button>
                  </div>
                </>
              )}

              {activeTab === "Receivables" && (
                <>
                  <div className={wsCreationcss.scrollArea}>
                    {receivable.map((r) => (
                      <div className="d-flex mb-2" key={r._id}>
                        <input
                          style={{ "margin": "0px", "margin-top": "3px" }}

                          type="checkbox"
                          checked={selectedReceivable.includes(r._id)}
                          disabled={isDisabled}
                          onChange={(e) => handleSelectReceivable(e, r._id)}
                        />
                        <span className="w-100 d-flex justify-content-between ml-2 mr-2">
                          <strong>{r.name}</strong>
                          <strong style={{ color: "#8B909A" }}>{r.company}</strong>
                        </span>
                      </div>
                    ))}
                  </div>
                  <hr />
                  <div className={commoncss.dFlexJustifysb}>
                    <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                      onClick={() => updateCheckedIR("all_checked_receivable", selectedReceivable)}
                      disabled={isDisabled}
                    >Import selected receivables</button>&ensp;
                    <button className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
                      onClick={importAllReceivable}
                      disabled={isDisabled}
                    >Import all receivables</button>
                  </div>
                </>
              )}
              {activeTab === "Leases" && (
                <>
                  <div className={wsCreationcss.scrollArea}>
                    {leases.map((r) => (
                      <div className="d-flex mb-2" key={r._id}>
                        <input
                          style={{ "margin": "0px", "margin-top": "3px" }}

                          type="checkbox"
                          checked={selectedLeases.includes(r._id)}
                          disabled={isDisabled}
                          onChange={(e) => handleSelectLeases(e, r._id)}
                        />
                        <span className="w-100 d-flex justify-content-between ml-2 mr-2">
                          <strong>{r.name}</strong>
                          <strong style={{ color: "#8B909A" }}>{r.company}</strong>
                        </span>
                      </div>
                    ))}
                  </div>
                  <hr />
                  <div className={commoncss.dFlexJustifysb}>
                    <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                      onClick={() => updateCheckedIR("all_checked_leases", selectedLeases)}
                      disabled={isDisabled}
                    >Import selected leases</button>&ensp;
                    <button className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
                      onClick={importAllLeases}
                      disabled={isDisabled}
                    >Import all leases</button>
                  </div>
                </>
              )}
              {activeTab === "Loans" && (
                <>
                  <div className={wsCreationcss.scrollArea}>
                    {loans.map((r) => (
                      <div className="d-flex mb-2" key={r._id}>
                        <input
                          style={{ "margin": "0px", "margin-top": "3px" }}

                          type="checkbox"
                          checked={selectedLoans.includes(r._id)}
                          disabled={isDisabled}
                          onChange={(e) => handleSelectLoans(e, r._id)}
                        />
                        <span className="w-100 d-flex justify-content-between ml-2 mr-2">
                          <strong>{r.name}</strong>
                          <strong style={{ color: "#8B909A" }}>{r.company}</strong>
                        </span>
                      </div>
                    ))}
                  </div>
                  <hr />
                  <div className={commoncss.dFlexJustifysb}>
                    <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                      onClick={() => updateCheckedIR("all_checked_loans", selectedLoans)}
                      disabled={isDisabled}
                    >Import selected loans</button>&ensp;
                    <button className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
                      onClick={importAllLoans}
                      disabled={isDisabled}
                    >Import all loans</button>
                  </div>
                </>
              )}
              {activeTab === "Payables" && (
                <>
                  <div className={wsCreationcss.scrollArea}>
                    {payable.map((r) => (
                      <div className="d-flex mb-2" key={r._id}>
                        <input
                          style={{ "margin": "0px", "margin-top": "3px" }}

                          type="checkbox"
                          checked={selectedPayable.includes(r._id)}
                          disabled={isDisabled}
                          onChange={(e) => handleSelectPayable(e, r._id)}
                        />
                        <span className="w-100 d-flex justify-content-between ml-2 mr-2">
                          <strong>{r.name}</strong>
                          <strong style={{ color: "#8B909A" }}>{r.company}</strong>
                        </span>
                      </div>
                    ))}
                  </div>
                  <hr />
                  <div className={commoncss.dFlexJustifysb}>
                    <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                      onClick={() => updateCheckedIR("all_checked_payable", selectedPayable)}
                      disabled={isDisabled}
                    >Import selected payables</button>&ensp;
                    <button className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
                      onClick={importAllPayable}
                      disabled={isDisabled}
                    >Import all payables</button>
                  </div>
                </>
              )}
              {activeTab === "Fixed Assets" && (
                <>
                  <div className={wsCreationcss.scrollArea}>
                    {fixedAssets.map((r) => (
                      <div className="d-flex mb-2" key={r._id} style={{ "align-items": "center" }}>
                          <input
                            style={{ "margin": "-20px 20px 0px 0px" }}
                            type="checkbox"
                            checked={selectedFixedAssets.includes(r._id)}
                          disabled={isDisabled}
                          onChange={(e) => handleSelectFixedAssets(e, r._id)}
                          />
                          <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "90%", "margin-bottom": "15px" }}>
                            <div className={commoncss.dFlexClm}>
                              <span className={wsCreationcss.wscLabel2}>
                                {r.name}
                              </span>
                              <span className={wsCreationcss.wscLabel3}>
                                {r?.companyData?.company_name}
                              </span>
                            </div>
                            <div className="d-flex" style={{ "gap": "14px" }}>
                              <div className={wsCreationcss.wscCard1}>
                                <span className={wsCreationcss.wscLabel4}>As on date</span>
                                <span className={wsCreationcss.wscLabel5}>{moment(r.asOnDate).format(
                                                                      "DD MMM YYYY"
                                                                    )}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                    ))}
                  </div>
                  <hr />
                  <div className={commoncss.dFlexJustifysb}>
                    <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                      onClick={() => updateCheckedIR("all_checked_fixed_assets", selectedFixedAssets)}
                      disabled={isDisabled}
                    >Import selected fixed assets</button>&ensp;
                    <button className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
                      onClick={importAllFixedAssets}
                      disabled={isDisabled}
                    >Import all fixed assets</button>
                  </div>
                </>
              )}

              {activeTab === "Sales" && (
                <>
                  <div className={wsCreationcss.scrollArea}>
                    {saleReg.map((r) => (
                      <div className="d-flex mb-2" key={r._id} style={{ "align-items": "center" }}>
                          <input
                            style={{ "margin": "-20px 20px 0px 0px" }}
                            type="checkbox"
                            checked={selectedSaleReg.includes(r._id)}
                          disabled={isDisabled}
                          onChange={(e) => handleSelectSalesReg(e, r._id)}
                          />
                          <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "90%", "margin-bottom": "15px" }}>
                            <div className={commoncss.dFlexClm}>
                              <span className={wsCreationcss.wscLabel2}>
                                {r.name}
                              </span>
                              <span className={wsCreationcss.wscLabel3}>
                                {r?.companyData?.company_name}
                              </span>
                            </div>
                            <div className="d-flex" style={{ "gap": "14px" }}>
                              <div className={wsCreationcss.wscCard1}>
                                <span className={wsCreationcss.wscLabel4}>As on date</span>
                                <span className={wsCreationcss.wscLabel5}>{moment(r.asOnDate).format(
                                                                      "DD MMM YYYY"
                                                                    )}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                    ))}
                  </div>
                  <hr />
                  <div className={commoncss.dFlexJustifysb}>
                    <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                      onClick={() => updateCheckedIR("all_checked_sale", selectedSaleReg)}
                      disabled={isDisabled}
                    >Import selected sales registers</button>&ensp;
                    <button className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
                      onClick={importAllSalesReg}
                      disabled={isDisabled}
                    >Import all sales registers</button>
                  </div>
                </>
              )}
              {activeTab === "Purchases" && (
                <>
                  <div className={wsCreationcss.scrollArea}>
                    {purchaseReg.map((r) => (
                      <div className="d-flex mb-2" key={r._id} style={{ "align-items": "center" }}>
                          <input
                            style={{ "margin": "-20px 20px 0px 0px" }}
                            type="checkbox"
                            checked={selectedPurchaseReg.includes(r._id)}
                          disabled={isDisabled}
                          onChange={(e) => handleSelectPurchaseReg(e, r._id)}
                          />
                          <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "90%", "margin-bottom": "15px" }}>
                            <div className={commoncss.dFlexClm}>
                              <span className={wsCreationcss.wscLabel2}>
                                {r.name}
                              </span>
                              <span className={wsCreationcss.wscLabel3}>
                                {r?.companyData?.company_name}
                              </span>
                            </div>
                            <div className="d-flex" style={{ "gap": "14px" }}>
                              <div className={wsCreationcss.wscCard1}>
                                <span className={wsCreationcss.wscLabel4}>As on date</span>
                                <span className={wsCreationcss.wscLabel5}>{moment(r.asOnDate).format(
                                                                      "DD MMM YYYY"
                                                                    )}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                    ))}
                  </div>
                  <hr />
                  <div className={commoncss.dFlexJustifysb}>
                    <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                      onClick={() => updateCheckedIR("all_checked_purchase", selectedPurchaseReg)}
                      disabled={isDisabled}
                    >Import selected purchase registers</button>&ensp;
                    <button className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }}
                      onClick={importAllPurchaseReg}
                      disabled={isDisabled}
                    >Import all purchase registers</button>
                  </div>
                </>
              )}
            </div>
          </div>
        </motion.div>
        <div className={wsCreationcss.footerContainer}>
          <div>
            <button
              onClick={() => history.push(`/dashboard`)}
              className={wsCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
          </div>
          <div className={wsCreationcss.footerbtnContainer}>
            <span className={wsCreationcss.skipForNow}
              onClick={skipNext} >Skip for now</span>
            <button
              className={wsCreationcss.perviewBtn} onClick={() => history.push(`/addCompanies/${id}`)}
              type="button" style={{ "padding": "7px" }}><PervBtnIcon height={19} />Previous</button>
            <button onClick={nextPageData} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>Next<RightIcon height={12} /></button>


          </div>
        </div>
      </div >
    </>
  );
};

export default ImportRegistersV2;
